module.exports = __webpack_public_path__ + "img/lightMonitoring.41f07fe7.svg";